module.exports = __webpack_public_path__ + "img/chiku05.45d64ca4.png";